import { isNil } from 'lodash-es';

export const formateValuesToFix1 = (value?: number) => {
  return !isNil(value) ? Number(value.toFixed(1)).toLocaleString() : '--';
};

// Gwh
export const GwhFormat = (value: number | undefined | null) => {
  if (undefined === value || null === value) return { value: '--', unit: '--' };
  if (typeof value === 'string') value = Number(value);
  if (value > 1000 * 1000) {
    return {
      value: `${(value / (1000 * 1000)).toLocaleString('zh', {
        maximumFractionDigits: 1,
      })}`,
      unit: 'GWh',
    };
  }
  if (value > 1000) {
    return {
      value: `${(value / 1000).toLocaleString('zh', {
        maximumFractionDigits: 1,
      })}`,
      unit: 'MWh',
    };
  }
  return {
    value: `${value.toLocaleString('zh', { maximumFractionDigits: 1 })}`,
    unit: 'kWh',
  };
};

// GW
export const GWFormat = (value: number | undefined | null) => {
  if (undefined === value || null === value) return { value: '--', unit: '--' };
  if (typeof value === 'string') value = Number(value);
  if (value > 1000 * 1000) {
    return {
      value: `${(value / (1000 * 1000)).toLocaleString('zh', {
        maximumFractionDigits: 1,
      })}`,
      unit: 'GW',
    };
  }
  if (value > 1000) {
    return {
      value: `${(value / 1000).toLocaleString('zh', {
        maximumFractionDigits: 1,
      })}`,
      unit: 'MW',
    };
  }
  return {
    value: `${value.toLocaleString('zh', { maximumFractionDigits: 1 })}`,
    unit: 'kW',
  };
};
